import styles from "../LoginSidebar.module.scss";

export const RegistrationTypeSwitcher = ({
  registrationType,
  onTypeChange,
}) => {
  return (
    <div className={styles.sidebarWrapper__regButtonsBlock}>
      <div
        className={
          registrationType === "individual"
            ? styles.sidebarWrapper__regBtnActive
            : styles.sidebarWrapper__regBtn
        }
        onClick={() => onTypeChange("individual")}
      >
        <p>Физ.лицо</p>
      </div>
      <div
        className={
          registrationType === "business"
            ? styles.sidebarWrapper__regBtnActive
            : styles.sidebarWrapper__regBtn
        }
        onClick={() => onTypeChange("business")}
      >
        <p>Юр.лицо</p>
      </div>
    </div>
  );
};
